import React from 'react';

export const MessengerContext = React.createContext<{
  unreadConversationsCount: number;
  fetchUnreadConversationsCount(): void;
}>({ unreadConversationsCount: 0, fetchUnreadConversationsCount: () => undefined });
MessengerContext.displayName = 'MessengerContext';

export default MessengerContext;
